export const Asset = {
    ID: "",
    Name: "",
    Archived: false,
    FieldIDs: [],
}

export default Asset;